<template>
  <div class="jc-section">
        <div class="jc-section-header">
          <h3 class="jc-section-title">{{$t('券额券信息')}}</h3>
        </div>
        <div class="jc-section-content">
            <jc-form class="jc-datashow-list">
      <jc-row :gutter="20">
        <jc-col :span="8">
          <jc-form-item :label="`${$t('券额码')}${$t('：')}`">
            <p>{{detail.number | filterParams}}</p>
          </jc-form-item>
        </jc-col>
        <jc-col :span="8">
          <jc-form-item :label="`${$t('券额金额（元）')}${$t('：')}`">
            <p>{{detail.fee | formatMoney}}</p>
          </jc-form-item>
        </jc-col>
        <jc-col :span="8">
          <jc-form-item :label="`${$t('券额余额（元）')}${$t('：')}`">
            <p>{{detail.balance | formatMoney}}</p>
          </jc-form-item>
        </jc-col>
        <jc-col :span="8">
          <jc-form-item :label="`${$t('是否支持转赠')}${$t('：')}`">
            <p v-if="detail.resend === 1">{{$t('是')}}</p>
            <p v-else>{{$t('否')}}</p>
          </jc-form-item>
        </jc-col>
        <!-- <jc-col :span="8">
          <jc-form-item :label="`${$t('是否支持发放代金券')}${$t('：')}`">
            <p v-if="detail.deliverCoupon === 1">{{$t('是')}}</p>
            <p v-else>{{$t('否')}}</p>
          </jc-form-item>
        </jc-col> -->
        <jc-col :span="8">
          <jc-form-item :label="`${$t('券额有效时间')}${$t('：')}`">
            <p v-if="detail.timeType === 2">{{`${detail.relativeTime} ${$t('天')}`}}</p>
            <p v-else>{{`${detail.validStartTime}-${detail.validEndTime}`}}</p>
          </jc-form-item>
        </jc-col>
        <jc-col :span="8">
          <jc-form-item :label="`${$t('发放代金券有效时间')}${$t('：')}`">
            <p v-if="detail.deliverTimeType === 2">{{`${detail.deliverRelativeTime} ${$t('天')}`}}</p>
           <p v-else>{{`${detail.deliverCouponStartTime}-${detail.deliverCouponEndTime}`}}</p>
          </jc-form-item>
        </jc-col>
        <jc-col :span="8">
          <jc-form-item :label="`${$t('绑定时间')}${$t('：')}`">
            <p>{{detail.bindTime | filterParams}}</p>
          </jc-form-item>
        </jc-col>
        <jc-col :span="8">
          <jc-form-item :label="`${$t('创建时间')}${$t('：')}`">
            <p>{{detail.createTime | filterParams}}</p>
          </jc-form-item>
        </jc-col>
        <jc-col :span="8">
          <jc-form-item :label="$t('状态_')">
            <p>{{detail.statusIndex | filterQuotaCouponStatus}}</p>
          </jc-form-item>
        </jc-col>
        <jc-col :span="8">
          <jc-form-item :label="`${$t('支持地域')}${$t('：')}`">
            <p>{{detail.region | filterRegion}}</p>
          </jc-form-item>
        </jc-col>
        <jc-col :span="8">
          <jc-form-item :label="`${$t('计费类型')}${$t('：')}`">
            <p>{{detail.billingType | filterBillingType}}</p>
          </jc-form-item>
        </jc-col>
        <jc-col :span="8">
          <jc-form-item :label="`${$t('适用产品线')}${$t('：')}`">
            <p>{{detail.appName | filterAppcode}}</p>
          </jc-form-item>
        </jc-col>
        
      </jc-row>
    </jc-form>
        </div>
      </div>
</template>
<script>
import { queryConsoleQuotaInfo } from '@/api/coupon-api.js'
export default {
  name: 'quotaRecord',
  props: ['quotaNumber', 'type'],
  data() {
    return {
      detail: {}
    }
  },
  methods: {
    async query() {
      try {
        let {
          body: {
            result: { data }
          }
        } = await queryConsoleQuotaInfo({ quotaNumber: this.quotaNumber })
        this.detail = data || {}
        this.permition(data)
        this.$emit('getDetail', this.detail)
      } catch (e) {
        console.log(e)
        this.detail = {}
      }
    },
    permition(detail) {
      if (
        (this.type === 'issue' && !detail.deliverCoupon) ||
        (this.type === 'resend' && !detail.resend)
      ) {
        this.$emit('noPermission')
      }
    }
  },
  created() {
    if (!this.quotaNumber) {
      this.$router.push({ path: '/cost/coupon' })
    }
    this.query()
  }
}
</script>
<style>
.form-tablelabel {
  margin-right: 10px;
}
</style>
